// src/tracking-status.enum.ts
var TrackingStatus = /* @__PURE__ */ ((TrackingStatus2) => {
  TrackingStatus2["NONE"] = "NONE";
  TrackingStatus2["PARCEL_NOT_SHIPPED"] = "PARCEL_NOT_SHIPPED";
  TrackingStatus2["ORDER_NOT_FULFILLED"] = "ORDER_NOT_FULFILLED";
  TrackingStatus2["PRE_TRANSIT"] = "PRE_TRANSIT";
  TrackingStatus2["IN_TRANSIT"] = "IN_TRANSIT";
  TrackingStatus2["AVAILABLE_FOR_PICKUP"] = "AVAILABLE_FOR_PICKUP";
  TrackingStatus2["REDIRECT_TO_PICKUP"] = "REDIRECT_TO_PICKUP";
  TrackingStatus2["WAITING_AT_PICKUP_POINT"] = "WAITING_AT_PICKUP_POINT";
  TrackingStatus2["WAITING_AT_PICKUP_POINT_SEVERE"] = "WAITING_AT_PICKUP_POINT_SEVERE";
  TrackingStatus2["WAITING_INFORMATION_FROM_ADDRESS"] = "WAITING_INFORMATION_FROM_ADDRESS";
  TrackingStatus2["DELIVERED_TO_NEIGHBOUR"] = "DELIVERED_TO_NEIGHBOUR";
  TrackingStatus2["DELIVERED"] = "DELIVERED";
  TrackingStatus2["RETURNED_TO_SENDER"] = "RETURNED_TO_SENDER";
  TrackingStatus2["EXCEPTION"] = "EXCEPTION";
  TrackingStatus2["OUT_FOR_DELIVERY"] = "OUT_FOR_DELIVERY";
  TrackingStatus2["DELIVERY_ATTEMPTED"] = "DELIVERY_ATTEMPTED";
  TrackingStatus2["COLLECTED_AT_PICKUP"] = "COLLECTED_AT_PICKUP";
  TrackingStatus2["DELAYED_PACKAGE"] = "DELAYED_PACKAGE";
  TrackingStatus2["CUSTOMS_CLEARANCE_START"] = "CUSTOMS_CLEARANCE_START";
  TrackingStatus2["CUSTOMS_CLEARANCE_COMPLETE"] = "CUSTOMS_CLEARANCE_COMPLETE";
  TrackingStatus2["DELAYED_PACKAGE_SEVERE"] = "DELAYED_PACKAGE_SEVERE";
  TrackingStatus2["CARRIER_DELAYED_PACKAGE"] = "CARRIER_DELAYED_PACKAGE";
  TrackingStatus2["DISPATCHED_TO_OTHER_PICKUP_POINT"] = "DISPATCHED_TO_OTHER_PICKUP_POINT";
  TrackingStatus2["STALE"] = "STALE";
  return TrackingStatus2;
})(TrackingStatus || {});
var ALL_TRACKING_STATUSES = Object.values(TrackingStatus);

// src/tracking-status.metadata.ts
var TRACKING_STATUS_CATEGORIES = [
  { id: "pre_transit", label: "Pr\xE9-exp\xE9dition" },
  { id: "in_transit", label: "En transit" },
  { id: "delivered", label: "Livr\xE9" },
  { id: "returned", label: "Retourn\xE9" },
  { id: "alert", label: "Alerte" }
];
var TRACKING_STATUS_CATEGORY_COLORS = {
  pre_transit: "#6b7280",
  // gray
  in_transit: "#3b82f6",
  // blue
  delivered: "#22c55e",
  // green
  returned: "#f97316",
  // orange
  alert: "#ef4444"
  // red
};
var METADATA = {
  // 1 - Pre-transit
  ["PRE_TRANSIT" /* PRE_TRANSIT */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "pre_transit",
    order: "1",
    icon: "CircleDashed"
  },
  ["PARCEL_NOT_SHIPPED" /* PARCEL_NOT_SHIPPED */]: {
    isSmartStatus: true,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "pre_transit",
    order: "1.2",
    icon: "CircleDashed"
  },
  ["ORDER_NOT_FULFILLED" /* ORDER_NOT_FULFILLED */]: {
    isSmartStatus: true,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "pre_transit",
    order: "1.3",
    icon: "CircleDashed"
  },
  ["NONE" /* NONE */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "pre_transit",
    order: null,
    icon: "CircleMinus"
  },
  // 2 - In transit
  ["IN_TRANSIT" /* IN_TRANSIT */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "in_transit",
    order: "2.1",
    icon: "Truck"
  },
  ["CUSTOMS_CLEARANCE_START" /* CUSTOMS_CLEARANCE_START */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "in_transit",
    order: "2.2",
    icon: "Shield"
  },
  ["CUSTOMS_CLEARANCE_COMPLETE" /* CUSTOMS_CLEARANCE_COMPLETE */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "in_transit",
    order: "2.3",
    icon: "ShieldCheck"
  },
  ["OUT_FOR_DELIVERY" /* OUT_FOR_DELIVERY */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "in_transit",
    order: "3.1",
    icon: "Truck"
  },
  ["REDIRECT_TO_PICKUP" /* REDIRECT_TO_PICKUP */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: true,
    isWaitingAtPickupPoint: false,
    category: "in_transit",
    order: "3.3",
    icon: "Truck"
  },
  ["AVAILABLE_FOR_PICKUP" /* AVAILABLE_FOR_PICKUP */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: true,
    category: "in_transit",
    order: "3.4",
    icon: "Warehouse"
  },
  ["WAITING_AT_PICKUP_POINT" /* WAITING_AT_PICKUP_POINT */]: {
    isSmartStatus: true,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: true,
    category: "in_transit",
    order: "3.5",
    icon: "Warehouse"
  },
  ["DISPATCHED_TO_OTHER_PICKUP_POINT" /* DISPATCHED_TO_OTHER_PICKUP_POINT */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: true,
    isWaitingAtPickupPoint: false,
    category: "in_transit",
    order: "3.8",
    icon: "Truck"
  },
  // 3 - Delivered
  ["DELIVERED" /* DELIVERED */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: true,
    isSuccessfulDelivery: true,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "delivered",
    order: "3.7",
    icon: "CircleCheck"
  },
  ["COLLECTED_AT_PICKUP" /* COLLECTED_AT_PICKUP */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: true,
    isSuccessfulDelivery: true,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "delivered",
    order: "3.9",
    icon: "CircleCheck"
  },
  ["DELIVERED_TO_NEIGHBOUR" /* DELIVERED_TO_NEIGHBOUR */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: true,
    isSuccessfulDelivery: true,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "delivered",
    order: "3.9.1",
    icon: "CircleCheck"
  },
  // 4 - Returned
  ["RETURNED_TO_SENDER" /* RETURNED_TO_SENDER */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: true,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "returned",
    order: "4",
    icon: "Truck"
  },
  // 5 - Alert
  ["DELAYED_PACKAGE" /* DELAYED_PACKAGE */]: {
    isSmartStatus: true,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "alert",
    order: "2.4",
    icon: "Clock"
  },
  ["DELAYED_PACKAGE_SEVERE" /* DELAYED_PACKAGE_SEVERE */]: {
    isSmartStatus: true,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "alert",
    order: "2.5",
    icon: "Clock"
  },
  ["CARRIER_DELAYED_PACKAGE" /* CARRIER_DELAYED_PACKAGE */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "alert",
    order: null,
    icon: "Clock"
  },
  ["WAITING_INFORMATION_FROM_ADDRESS" /* WAITING_INFORMATION_FROM_ADDRESS */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "alert",
    order: "3",
    icon: "CircleAlert"
  },
  ["DELIVERY_ATTEMPTED" /* DELIVERY_ATTEMPTED */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "alert",
    order: "3.2",
    icon: "Truck"
  },
  ["WAITING_AT_PICKUP_POINT_SEVERE" /* WAITING_AT_PICKUP_POINT_SEVERE */]: {
    isSmartStatus: true,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: true,
    category: "alert",
    order: "3.6",
    icon: "Warehouse"
  },
  ["EXCEPTION" /* EXCEPTION */]: {
    isSmartStatus: false,
    isDeprecated: false,
    isFinalStatus: false,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "alert",
    order: "4.1",
    icon: "CircleX"
  },
  ["STALE" /* STALE */]: {
    isSmartStatus: true,
    isDeprecated: false,
    isFinalStatus: true,
    isSuccessfulDelivery: false,
    isNeverSkippable: false,
    isWaitingAtPickupPoint: false,
    category: "alert",
    order: "4.2",
    icon: "CircleDashed"
  }
};
function getTrackingStatusMetadata(status) {
  return METADATA[status];
}
function isSmartStatus(status) {
  return METADATA[status].isSmartStatus;
}
function isDeprecatedStatus(status) {
  return METADATA[status].isDeprecated;
}
function isFinalStatus(status) {
  return METADATA[status].isFinalStatus;
}
function isSuccessfulDelivery(status) {
  return METADATA[status].isSuccessfulDelivery;
}
function isNeverSkippableStatus(status) {
  return METADATA[status].isNeverSkippable;
}
function getNeverSkippableStatuses() {
  return Object.entries(METADATA).filter(([, meta]) => meta.isNeverSkippable).map(([status]) => status);
}
function getFinalStatuses() {
  return Object.entries(METADATA).filter(([, meta]) => meta.isFinalStatus).map(([status]) => status);
}
function getWaitingAtPickupPointStatuses() {
  return Object.entries(METADATA).filter(([, meta]) => meta.isWaitingAtPickupPoint).map(([status]) => status);
}
function getSuccessfulDeliveryStatuses() {
  return Object.entries(METADATA).filter(([, meta]) => meta.isSuccessfulDelivery).map(([status]) => status);
}
function getTrackingStatusesByCategory(category) {
  return Object.entries(METADATA).filter(([, meta]) => meta.category === category && !meta.isDeprecated).map(([status]) => status);
}
function compareOrder(a, b) {
  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1;
  const partsA = a.split(".").map(Number);
  const partsB = b.split(".").map(Number);
  const maxLength = Math.max(partsA.length, partsB.length);
  for (let i = 0; i < maxLength; i++) {
    const numA = partsA[i] ?? 0;
    const numB = partsB[i] ?? 0;
    if (numA !== numB) return numA - numB;
  }
  return 0;
}
function compareTrackingStatusOrder(a, b) {
  return compareOrder(METADATA[a].order, METADATA[b].order);
}
function getTrackingStatusCategoryColor(category) {
  return TRACKING_STATUS_CATEGORY_COLORS[category];
}
function getTrackingStatusColor(status) {
  return TRACKING_STATUS_CATEGORY_COLORS[METADATA[status].category];
}
function getTrackingStatusIcon(status) {
  return METADATA[status].icon;
}

// src/tracking-status.translations.ts
var SUPPORTED_LOCALES = ["fr", "en", "de", "es", "it"];
var CUSTOMER_SUPPORTED_LOCALES = [
  "bg",
  "cs",
  "da",
  "de",
  "en",
  "es",
  "fi",
  "fr",
  "hu",
  "it",
  "nl",
  "no",
  "pl",
  "pt",
  "sk",
  "sv"
];
var TrackingStatusTranslations = {
  ["NONE" /* NONE */]: {
    internalTitle: {
      fr: "Aucun statut",
      en: "No status",
      de: "Kein Status",
      es: "Sin estado",
      it: "Nessuno stato"
    },
    title: {
      fr: "En attente d'informations",
      en: "Awaiting information",
      de: "Warten auf Informationen",
      es: "Esperando informaci\xF3n",
      it: "In attesa di informazioni",
      bg: "\u041E\u0447\u0430\u043A\u0432\u0430 \u0441\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F",
      cs: "\u010Cek\xE1n\xED na informace",
      da: "Venter p\xE5 information",
      fi: "Odottaa tietoja",
      hu: "Inform\xE1ci\xF3ra v\xE1r",
      nl: "Wachten op informatie",
      no: "Venter p\xE5 informasjon",
      pl: "Oczekiwanie na informacje",
      pt: "Aguardando informa\xE7\xE3o",
      sk: "\u010Cakanie na inform\xE1cie",
      sv: "V\xE4ntar p\xE5 information"
    },
    description: {
      fr: "Aucune information de tracking disponible",
      en: "No tracking information available",
      de: "Keine Tracking-Informationen verf\xFCgbar",
      es: "No hay informaci\xF3n de seguimiento disponible",
      it: "Nessuna informazione di tracciamento disponibile",
      bg: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0437\u0430 \u043F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435",
      cs: "\u017D\xE1dn\xE9 informace o sledov\xE1n\xED nejsou k dispozici",
      da: "Ingen sporingsoplysninger tilg\xE6ngelige",
      fi: "Ei seurantatietoja saatavilla",
      hu: "Nincs el\xE9rhet\u0151 nyomk\xF6vet\xE9si inform\xE1ci\xF3",
      nl: "Geen trackinginformatie beschikbaar",
      no: "Ingen sporingsinformasjon tilgjengelig",
      pl: "Brak dost\u0119pnych informacji o \u015Bledzeniu",
      pt: "Nenhuma informa\xE7\xE3o de rastreamento dispon\xEDvel",
      sk: "\u017Diadne inform\xE1cie o sledovan\xED nie s\xFA k dispoz\xEDcii",
      sv: "Ingen sp\xE5rningsinformation tillg\xE4nglig"
    },
    internalDescription: {
      fr: "Aucune information de tracking disponible. Le colis vient d'\xEAtre cr\xE9\xE9 dans le syst\xE8me mais n'a pas encore de donn\xE9es du transporteur.",
      en: "No tracking information available. The parcel has just been created in the system but has no carrier data yet.",
      de: "Keine Tracking-Informationen verf\xFCgbar. Das Paket wurde gerade im System erstellt, hat aber noch keine Daten vom Spediteur.",
      es: "No hay informaci\xF3n de seguimiento disponible. El paquete acaba de ser creado en el sistema pero a\xFAn no tiene datos del transportista.",
      it: "Nessuna informazione di tracciamento disponibile. Il pacco \xE8 appena stato creato nel sistema ma non ha ancora dati del corriere."
    }
  },
  ["PARCEL_NOT_SHIPPED" /* PARCEL_NOT_SHIPPED */]: {
    internalTitle: {
      fr: "Absence de tracking prolong\xE9e",
      en: "Extended tracking absence",
      de: "L\xE4ngere Tracking-Abwesenheit",
      es: "Ausencia prolongada de seguimiento",
      it: "Assenza prolungata di tracciamento"
    },
    title: {
      fr: "Colis en pr\xE9paration",
      en: "Parcel being prepared",
      de: "Paket wird vorbereitet",
      es: "Paquete en preparaci\xF3n",
      it: "Pacco in preparazione",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0441\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u044F",
      cs: "Bal\xEDk se p\u0159ipravuje",
      da: "Pakke under forberedelse",
      fi: "Pakettia valmistellaan",
      hu: "Csomag el\u0151k\xE9sz\xEDt\xE9s alatt",
      nl: "Pakket wordt voorbereid",
      no: "Pakke under forberedelse",
      pl: "Paczka jest przygotowywana",
      pt: "Pacote em prepara\xE7\xE3o",
      sk: "Bal\xEDk sa pripravuje",
      sv: "Paket f\xF6rbereds"
    },
    description: {
      fr: "Aucun \xE9v\xE9nement de tracking depuis la cr\xE9ation de l'\xE9tiquette",
      en: "No tracking event since label creation",
      de: "Kein Tracking-Ereignis seit der Etikettenerstellung",
      es: "Ning\xFAn evento de seguimiento desde la creaci\xF3n de la etiqueta",
      it: "Nessun evento di tracciamento dalla creazione dell'etichetta",
      bg: "\u041D\u044F\u043C\u0430 \u0441\u044A\u0431\u0438\u0442\u0438\u0435 \u0437\u0430 \u043F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435 \u043E\u0442 \u0441\u044A\u0437\u0434\u0430\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0435\u0442\u0438\u043A\u0435\u0442\u0430",
      cs: "\u017D\xE1dn\xE1 ud\xE1lost sledov\xE1n\xED od vytvo\u0159en\xED \u0161t\xEDtku",
      da: "Ingen sporingsh\xE6ndelse siden oprettelse af etiket",
      fi: "Ei seurantatapahtumaa etiketin luomisen j\xE4lkeen",
      hu: "Nincs nyomk\xF6vet\xE9si esem\xE9ny a c\xEDmke l\xE9trehoz\xE1sa \xF3ta",
      nl: "Geen trackingevenement sinds het aanmaken van het label",
      no: "Ingen sporingshendelse siden opprettelse av etikett",
      pl: "Brak zdarzenia \u015Bledzenia od utworzenia etykiety",
      pt: "Nenhum evento de rastreamento desde a cria\xE7\xE3o da etiqueta",
      sk: "\u017Diadna udalos\u0165 sledovania od vytvorenia \u0161t\xEDtku",
      sv: "Ingen sp\xE5rningsh\xE4ndelse sedan etikettskapande"
    },
    internalDescription: {
      fr: "(Smart \u2013 J+3) Aucun \xE9v\xE9nement de tracking n'a \xE9t\xE9 d\xE9tect\xE9 depuis la cr\xE9ation de l'\xE9tiquette ; un retard logistique ou un retard de collecte est probable.",
      en: "(Smart \u2013 D+3) No tracking event has been detected since label creation; a logistics or collection delay is likely.",
      de: "(Smart \u2013 T+3) Seit der Etikettenerstellung wurde kein Tracking-Ereignis erkannt; eine logistische Verz\xF6gerung oder Abholungsverz\xF6gerung ist wahrscheinlich.",
      es: "(Smart \u2013 D+3) No se ha detectado ning\xFAn evento de seguimiento desde la creaci\xF3n de la etiqueta; es probable un retraso log\xEDstico o de recogida.",
      it: "(Smart \u2013 G+3) Nessun evento di tracciamento \xE8 stato rilevato dalla creazione dell'etichetta; \xE8 probabile un ritardo logistico o di ritiro."
    }
  },
  ["ORDER_NOT_FULFILLED" /* ORDER_NOT_FULFILLED */]: {
    internalTitle: {
      fr: "Traitement logistique en attente",
      en: "Awaiting logistics processing",
      de: "Warten auf logistische Bearbeitung",
      es: "Esperando procesamiento log\xEDstico",
      it: "In attesa di elaborazione logistica"
    },
    title: {
      fr: "Commande en cours de traitement",
      en: "Order being processed",
      de: "Bestellung wird bearbeitet",
      es: "Pedido en proceso",
      it: "Ordine in elaborazione",
      bg: "\u041F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430 \u0441\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0432\u0430",
      cs: "Objedn\xE1vka se zpracov\xE1v\xE1",
      da: "Ordre behandles",
      fi: "Tilausta k\xE4sitell\xE4\xE4n",
      hu: "Rendel\xE9s feldolgoz\xE1s alatt",
      nl: "Bestelling wordt verwerkt",
      no: "Bestilling behandles",
      pl: "Zam\xF3wienie w trakcie realizacji",
      pt: "Pedido em processamento",
      sk: "Objedn\xE1vka sa spracov\xE1va",
      sv: "Best\xE4llning behandlas"
    },
    description: {
      fr: "Commande en attente de traitement depuis plusieurs jours",
      en: "Order awaiting processing for several days",
      de: "Bestellung wartet seit mehreren Tagen auf Bearbeitung",
      es: "Pedido en espera de procesamiento desde hace varios d\xEDas",
      it: "Ordine in attesa di elaborazione da diversi giorni",
      bg: "\u041F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430 \u0447\u0430\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043E\u0442 \u043D\u044F\u043A\u043E\u043B\u043A\u043E \u0434\u043D\u0438",
      cs: "Objedn\xE1vka \u010Dek\xE1 na zpracov\xE1n\xED n\u011Bkolik dn\xED",
      da: "Ordre venter p\xE5 behandling i flere dage",
      fi: "Tilaus odottaa k\xE4sittely\xE4 useita p\xE4ivi\xE4",
      hu: "A rendel\xE9s t\xF6bb napja v\xE1r feldolgoz\xE1sra",
      nl: "Bestelling wacht al meerdere dagen op verwerking",
      no: "Bestilling venter p\xE5 behandling i flere dager",
      pl: "Zam\xF3wienie czeka na realizacj\u0119 od kilku dni",
      pt: "Pedido aguardando processamento h\xE1 v\xE1rios dias",
      sk: "Objedn\xE1vka \u010Dak\xE1 na spracovanie nieko\u013Eko dn\xED",
      sv: "Best\xE4llning v\xE4ntar p\xE5 behandling i flera dagar"
    },
    internalDescription: {
      fr: "(Smart \u2013 J+3) La commande est en attente de traitement logistique depuis plusieurs jours sans g\xE9n\xE9ration d'\xE9tiquette ; un blocage interne (pic d'activit\xE9, stock\u2026) est probable.",
      en: "(Smart \u2013 D+3) The order has been awaiting logistics processing for several days without label generation; an internal blockage (peak activity, stock\u2026) is likely.",
      de: "(Smart \u2013 T+3) Die Bestellung wartet seit mehreren Tagen auf die logistische Bearbeitung ohne Etikettenerstellung; eine interne Blockade (Spitzenaktivit\xE4t, Lagerbestand\u2026) ist wahrscheinlich.",
      es: "(Smart \u2013 D+3) El pedido ha estado esperando el procesamiento log\xEDstico durante varios d\xEDas sin generaci\xF3n de etiqueta; es probable un bloqueo interno (pico de actividad, stock\u2026).",
      it: "(Smart \u2013 G+3) L'ordine \xE8 in attesa di elaborazione logistica da diversi giorni senza generazione di etichetta; \xE8 probabile un blocco interno (picco di attivit\xE0, stock\u2026)."
    }
  },
  ["PRE_TRANSIT" /* PRE_TRANSIT */]: {
    internalTitle: {
      fr: "\xC9tiquette g\xE9n\xE9r\xE9e, aucun tracking",
      en: "Label generated, no tracking",
      de: "Etikett erstellt, kein Tracking",
      es: "Etiqueta generada, sin seguimiento",
      it: "Etichetta generata, nessun tracciamento"
    },
    title: {
      fr: "Colis pr\xEAt \xE0 \xEAtre exp\xE9di\xE9",
      en: "Parcel ready to ship",
      de: "Paket versandbereit",
      es: "Paquete listo para enviar",
      it: "Pacco pronto per la spedizione",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430 \u0433\u043E\u0442\u043E\u0432\u0430 \u0437\u0430 \u0438\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435",
      cs: "Bal\xEDk p\u0159ipraven k odesl\xE1n\xED",
      da: "Pakke klar til afsendelse",
      fi: "Paketti valmis l\xE4hetett\xE4v\xE4ksi",
      hu: "Csomag sz\xE1ll\xEDt\xE1sra k\xE9sz",
      nl: "Pakket klaar voor verzending",
      no: "Pakke klar til sending",
      pl: "Paczka gotowa do wysy\u0142ki",
      pt: "Pacote pronto para envio",
      sk: "Bal\xEDk pripraven\xFD na odoslanie",
      sv: "Paket redo f\xF6r leverans"
    },
    description: {
      fr: "\xC9tiquette g\xE9n\xE9r\xE9e, en attente de prise en charge",
      en: "Label generated, awaiting pickup",
      de: "Etikett erstellt, wartet auf Abholung",
      es: "Etiqueta generada, esperando recogida",
      it: "Etichetta generata, in attesa di ritiro",
      bg: "\u0415\u0442\u0438\u043A\u0435\u0442\u044A\u0442 \u0435 \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0430\u043D, \u0438\u0437\u0447\u0430\u043A\u0432\u0430 \u0441\u0435 \u043F\u0440\u0438\u0435\u043C\u0430\u043D\u0435",
      cs: "\u0160t\xEDtek vygenerov\xE1n, \u010Dek\xE1 na vyzvednut\xED",
      da: "Etiket genereret, venter p\xE5 afhentning",
      fi: "Etiketti luotu, odottaa noutoa",
      hu: "C\xEDmke l\xE9trehozva, felv\xE9telre v\xE1r",
      nl: "Label aangemaakt, wacht op ophalen",
      no: "Etikett generert, venter p\xE5 henting",
      pl: "Etykieta wygenerowana, oczekuje na odbi\xF3r",
      pt: "Etiqueta gerada, aguardando coleta",
      sk: "\u0160t\xEDtok vygenerovan\xFD, \u010Dak\xE1 na vyzdvihnutie",
      sv: "Etikett skapad, v\xE4ntar p\xE5 upph\xE4mtning"
    },
    internalDescription: {
      fr: "L'\xE9tiquette de transport a \xE9t\xE9 g\xE9n\xE9r\xE9e dans Shopify. Aucun \xE9v\xE9nement de tracking n'a encore \xE9t\xE9 enregistr\xE9 ; le colis est toujours chez l'exp\xE9diteur.",
      en: "The shipping label has been generated in Shopify. No tracking event has been recorded yet; the parcel is still with the sender.",
      de: "Das Versandetikett wurde in Shopify erstellt. Es wurde noch kein Tracking-Ereignis registriert; das Paket befindet sich noch beim Absender.",
      es: "La etiqueta de env\xEDo ha sido generada en Shopify. A\xFAn no se ha registrado ning\xFAn evento de seguimiento; el paquete todav\xEDa est\xE1 con el remitente.",
      it: "L'etichetta di spedizione \xE8 stata generata in Shopify. Non \xE8 stato ancora registrato alcun evento di tracciamento; il pacco \xE8 ancora presso il mittente."
    }
  },
  ["IN_TRANSIT" /* IN_TRANSIT */]: {
    internalTitle: {
      fr: "Colis pris en charge par le transporteur",
      en: "Parcel picked up by carrier",
      de: "Paket vom Spediteur abgeholt",
      es: "Paquete recogido por el transportista",
      it: "Pacco ritirato dal corriere"
    },
    title: {
      fr: "Colis en cours d'acheminement",
      en: "Parcel in transit",
      de: "Paket unterwegs",
      es: "Paquete en tr\xE1nsito",
      it: "Pacco in transito",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430 \u0432 \u0442\u0440\u0430\u043D\u0437\u0438\u0442",
      cs: "Bal\xEDk na cest\u011B",
      da: "Pakke undervejs",
      fi: "Paketti matkalla",
      hu: "Csomag \xFAton van",
      nl: "Pakket onderweg",
      no: "Pakke p\xE5 vei",
      pl: "Paczka w drodze",
      pt: "Pacote em tr\xE2nsito",
      sk: "Bal\xEDk na ceste",
      sv: "Paket p\xE5 v\xE4g"
    },
    description: {
      fr: "Le colis est en cours d'acheminement",
      en: "The parcel is in transit",
      de: "Das Paket ist unterwegs",
      es: "El paquete est\xE1 en tr\xE1nsito",
      it: "Il pacco \xE8 in transito",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0435 \u0432 \u0442\u0440\u0430\u043D\u0437\u0438\u0442",
      cs: "Bal\xEDk je na cest\u011B",
      da: "Pakken er p\xE5 vej",
      fi: "Paketti on matkalla",
      hu: "A csomag \xFAton van",
      nl: "Het pakket is onderweg",
      no: "Pakken er p\xE5 vei",
      pl: "Paczka jest w drodze",
      pt: "O pacote est\xE1 em tr\xE2nsito",
      sk: "Bal\xEDk je na ceste",
      sv: "Paketet \xE4r p\xE5 v\xE4g"
    },
    internalDescription: {
      fr: "Le colis a quitt\xE9 l'entrep\xF4t de l'exp\xE9diteur et a \xE9t\xE9 pris en charge par le transporteur ; il est en cours d'acheminement.",
      en: "The parcel has left the sender's warehouse and has been picked up by the carrier; it is in transit.",
      de: "Das Paket hat das Lager des Absenders verlassen und wurde vom Spediteur abgeholt; es ist unterwegs.",
      es: "El paquete ha salido del almac\xE9n del remitente y ha sido recogido por el transportista; est\xE1 en tr\xE1nsito.",
      it: "Il pacco ha lasciato il magazzino del mittente ed \xE8 stato ritirato dal corriere; \xE8 in transito."
    }
  },
  ["AVAILABLE_FOR_PICKUP" /* AVAILABLE_FOR_PICKUP */]: {
    internalTitle: {
      fr: "Colis disponible en point de retrait",
      en: "Parcel available for pickup",
      de: "Paket zur Abholung bereit",
      es: "Paquete disponible para recoger",
      it: "Pacco disponibile per il ritiro"
    },
    title: {
      fr: "Colis \xE0 r\xE9cup\xE9rer",
      en: "Parcel ready for collection",
      de: "Paket abholbereit",
      es: "Paquete listo para recoger",
      it: "Pacco pronto per il ritiro",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430 \u0433\u043E\u0442\u043E\u0432\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435",
      cs: "Bal\xEDk p\u0159ipraven k vyzvednut\xED",
      da: "Pakke klar til afhentning",
      fi: "Paketti noudettavissa",
      hu: "Csomag \xE1tv\xE9telre k\xE9sz",
      nl: "Pakket klaar voor afhaling",
      no: "Pakke klar for henting",
      pl: "Paczka gotowa do odbioru",
      pt: "Pacote pronto para coleta",
      sk: "Bal\xEDk pripraven\xFD na vyzdvihnutie",
      sv: "Paket redo f\xF6r upph\xE4mtning"
    },
    description: {
      fr: "Le colis est disponible en point de retrait",
      en: "The parcel is available at pickup point",
      de: "Das Paket ist an der Abholstelle verf\xFCgbar",
      es: "El paquete est\xE1 disponible en el punto de recogida",
      it: "Il pacco \xE8 disponibile presso il punto di ritiro",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0435 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0432 \u043F\u0443\u043D\u043A\u0442\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435",
      cs: "Bal\xEDk je k dispozici na v\xFDdejn\xEDm m\xEDst\u011B",
      da: "Pakken er tilg\xE6ngelig p\xE5 afhentningsstedet",
      fi: "Paketti on noudettavissa noutopisteess\xE4",
      hu: "A csomag el\xE9rhet\u0151 az \xE1tv\xE9teli ponton",
      nl: "Het pakket is beschikbaar op het afhaalpunt",
      no: "Pakken er tilgjengelig p\xE5 hentepunktet",
      pl: "Paczka jest dost\u0119pna w punkcie odbioru",
      pt: "O pacote est\xE1 dispon\xEDvel no ponto de coleta",
      sk: "Bal\xEDk je k dispoz\xEDcii na v\xFDdajnom mieste",
      sv: "Paketet finns tillg\xE4ngligt p\xE5 upph\xE4mtningsst\xE4llet"
    },
    internalDescription: {
      fr: "Le colis est disponible en point de retrait ; il est pr\xEAt \xE0 \xEAtre r\xE9cup\xE9r\xE9 par le client.",
      en: "The parcel is available at a pickup point; it is ready to be collected by the customer.",
      de: "Das Paket ist an einer Abholstelle verf\xFCgbar; es ist bereit zur Abholung durch den Kunden.",
      es: "El paquete est\xE1 disponible en un punto de recogida; est\xE1 listo para ser recogido por el cliente.",
      it: "Il pacco \xE8 disponibile presso un punto di ritiro; \xE8 pronto per essere ritirato dal cliente."
    }
  },
  ["REDIRECT_TO_PICKUP" /* REDIRECT_TO_PICKUP */]: {
    internalTitle: {
      fr: "Colis d\xE9pos\xE9 en point de retrait",
      en: "Parcel dropped at pickup point",
      de: "Paket an Abholstelle abgegeben",
      es: "Paquete dejado en punto de recogida",
      it: "Pacco lasciato al punto di ritiro"
    },
    title: {
      fr: "Colis d\xE9pos\xE9 en point relais",
      en: "Parcel left at pickup point",
      de: "Paket an Abholstelle hinterlegt",
      es: "Paquete dejado en punto de recogida",
      it: "Pacco lasciato al punto di ritiro",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430 \u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430 \u0432 \u043F\u0443\u043D\u043A\u0442 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435",
      cs: "Bal\xEDk ponech\xE1n na v\xFDdejn\xEDm m\xEDst\u011B",
      da: "Pakke efterladt p\xE5 afhentningssted",
      fi: "Paketti j\xE4tetty noutopisteeseen",
      hu: "Csomag hagyva az \xE1tv\xE9teli ponton",
      nl: "Pakket achtergelaten bij afhaalpunt",
      no: "Pakke lagt igjen p\xE5 hentepunkt",
      pl: "Paczka pozostawiona w punkcie odbioru",
      pt: "Pacote deixado no ponto de coleta",
      sk: "Bal\xEDk ponechan\xFD na v\xFDdajnom mieste",
      sv: "Paket l\xE4mnat p\xE5 upph\xE4mtningsst\xE4lle"
    },
    description: {
      fr: "Absent lors de la livraison, colis en point de retrait",
      en: "Absent during delivery, parcel at pickup point",
      de: "Bei Lieferung abwesend, Paket an Abholstelle",
      es: "Ausente durante la entrega, paquete en punto de recogida",
      it: "Assente durante la consegna, pacco al punto di ritiro",
      bg: "\u041E\u0442\u0441\u044A\u0441\u0442\u0432\u0438\u0435 \u043F\u0440\u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430, \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0435 \u0432 \u043F\u0443\u043D\u043A\u0442 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435",
      cs: "Nep\u0159\xEDtomnost p\u0159i doru\u010Den\xED, bal\xEDk na v\xFDdejn\xEDm m\xEDst\u011B",
      da: "Frav\xE6rende ved levering, pakke p\xE5 afhentningssted",
      fi: "Poissa toimituksen aikana, paketti noutopisteess\xE4",
      hu: "T\xE1voll\xE9t a k\xE9zbes\xEDt\xE9skor, csomag az \xE1tv\xE9teli ponton",
      nl: "Afwezig bij bezorging, pakket bij afhaalpunt",
      no: "Frav\xE6rende ved levering, pakke p\xE5 hentepunkt",
      pl: "Nieobecno\u015B\u0107 przy dostawie, paczka w punkcie odbioru",
      pt: "Ausente durante a entrega, pacote no ponto de coleta",
      sk: "Nepr\xEDtomnos\u0165 pri doru\u010Den\xED, bal\xEDk na v\xFDdajnom mieste",
      sv: "Fr\xE5nvarande vid leverans, paket p\xE5 upph\xE4mtningsst\xE4lle"
    },
    internalDescription: {
      fr: "Le destinataire \xE9tait absent lors d'une livraison n\xE9cessitant une remise en main propre ; le colis a \xE9t\xE9 d\xE9pos\xE9 en point de retrait \xE0 proximit\xE9.",
      en: "The recipient was absent during a delivery requiring hand-to-hand delivery; the parcel has been dropped at a nearby pickup point.",
      de: "Der Empf\xE4nger war bei einer Lieferung, die eine pers\xF6nliche \xDCbergabe erforderte, abwesend; das Paket wurde an einer nahegelegenen Abholstelle abgegeben.",
      es: "El destinatario estaba ausente durante una entrega que requer\xEDa entrega en mano; el paquete ha sido dejado en un punto de recogida cercano.",
      it: "Il destinatario era assente durante una consegna che richiedeva la consegna a mano; il pacco \xE8 stato lasciato in un punto di ritiro vicino."
    }
  },
  ["WAITING_AT_PICKUP_POINT" /* WAITING_AT_PICKUP_POINT */]: {
    internalTitle: {
      fr: "Colis en point de retrait depuis plusieurs jours",
      en: "Parcel at pickup point for several days",
      de: "Paket seit mehreren Tagen an der Abholstelle",
      es: "Paquete en punto de recogida desde hace varios d\xEDas",
      it: "Pacco al punto di ritiro da diversi giorni"
    },
    title: {
      fr: "Colis en attente de retrait",
      en: "Parcel awaiting collection",
      de: "Paket wartet auf Abholung",
      es: "Paquete en espera de recogida",
      it: "Pacco in attesa di ritiro",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430 \u0447\u0430\u043A\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435",
      cs: "Bal\xEDk \u010Dek\xE1 na vyzvednut\xED",
      da: "Pakke venter p\xE5 afhentning",
      fi: "Paketti odottaa noutoa",
      hu: "Csomag \xE1tv\xE9telre v\xE1r",
      nl: "Pakket wacht op afhaling",
      no: "Pakke venter p\xE5 henting",
      pl: "Paczka oczekuje na odbi\xF3r",
      pt: "Pacote aguardando coleta",
      sk: "Bal\xEDk \u010Dak\xE1 na vyzdvihnutie",
      sv: "Paket v\xE4ntar p\xE5 upph\xE4mtning"
    },
    description: {
      fr: "Colis disponible depuis plusieurs jours",
      en: "Parcel available for several days",
      de: "Paket seit mehreren Tagen verf\xFCgbar",
      es: "Paquete disponible desde hace varios d\xEDas",
      it: "Pacco disponibile da diversi giorni",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0435 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u043E\u0442 \u043D\u044F\u043A\u043E\u043B\u043A\u043E \u0434\u043D\u0438",
      cs: "Bal\xEDk je k dispozici ji\u017E n\u011Bkolik dn\xED",
      da: "Pakke tilg\xE6ngelig i flere dage",
      fi: "Paketti ollut saatavilla useita p\xE4ivi\xE4",
      hu: "A csomag t\xF6bb napja el\xE9rhet\u0151",
      nl: "Pakket beschikbaar sinds meerdere dagen",
      no: "Pakke tilgjengelig i flere dager",
      pl: "Paczka dost\u0119pna od kilku dni",
      pt: "Pacote dispon\xEDvel h\xE1 v\xE1rios dias",
      sk: "Bal\xEDk je k dispoz\xEDcii u\u017E nieko\u013Eko dn\xED",
      sv: "Paket tillg\xE4ngligt i flera dagar"
    },
    internalDescription: {
      fr: "(Smart \u2013 J+3) Le colis est disponible en point de retrait depuis plusieurs jours ; le client est invit\xE9 \xE0 le r\xE9cup\xE9rer rapidement.",
      en: "(Smart \u2013 D+3) The parcel has been available at a pickup point for several days; the customer is invited to collect it promptly.",
      de: "(Smart \u2013 T+3) Das Paket ist seit mehreren Tagen an einer Abholstelle verf\xFCgbar; der Kunde wird gebeten, es zeitnah abzuholen.",
      es: "(Smart \u2013 D+3) El paquete ha estado disponible en un punto de recogida durante varios d\xEDas; se invita al cliente a recogerlo r\xE1pidamente.",
      it: "(Smart \u2013 G+3) Il pacco \xE8 disponibile presso un punto di ritiro da diversi giorni; il cliente \xE8 invitato a ritirarlo rapidamente."
    }
  },
  ["WAITING_AT_PICKUP_POINT_SEVERE" /* WAITING_AT_PICKUP_POINT_SEVERE */]: {
    internalTitle: {
      fr: "Colis en point de retrait en fin de disponibilit\xE9",
      en: "Parcel at pickup point nearing expiration",
      de: "Paket an Abholstelle kurz vor Ablauf",
      es: "Paquete en punto de recogida pr\xF3ximo a vencer",
      it: "Pacco al punto di ritiro in scadenza"
    },
    title: {
      fr: "Colis \xE0 r\xE9cup\xE9rer urgemment",
      en: "Parcel requires urgent collection",
      de: "Paket dringend abzuholen",
      es: "Paquete requiere recogida urgente",
      it: "Pacco richiede ritiro urgente",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0438\u0437\u0438\u0441\u043A\u0432\u0430 \u0441\u043F\u0435\u0448\u043D\u043E \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435",
      cs: "Bal\xEDk vy\u017Eaduje urgentn\xED vyzvednut\xED",
      da: "Pakke kr\xE6ver hurtig afhentning",
      fi: "Paketti vaatii kiireellisen noudon",
      hu: "A csomag s\xFCrg\u0151s \xE1tv\xE9telt ig\xE9nyel",
      nl: "Pakket vereist dringende afhaling",
      no: "Pakke krever snarest mulig henting",
      pl: "Paczka wymaga pilnego odbioru",
      pt: "Pacote requer coleta urgente",
      sk: "Bal\xEDk vy\u017Eaduje urgentn\xE9 vyzdvihnutie",
      sv: "Paketet kr\xE4ver br\xE5dskande upph\xE4mtning"
    },
    description: {
      fr: "Derniers jours pour r\xE9cup\xE9rer le colis",
      en: "Last days to collect the parcel",
      de: "Letzte Tage zur Abholung des Pakets",
      es: "\xDAltimos d\xEDas para recoger el paquete",
      it: "Ultimi giorni per ritirare il pacco",
      bg: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438 \u0434\u043D\u0438 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430",
      cs: "Posledn\xED dny k vyzvednut\xED bal\xEDku",
      da: "Sidste dage til at hente pakken",
      fi: "Viimeiset p\xE4iv\xE4t noutaa paketti",
      hu: "Utols\xF3 napok a csomag \xE1tv\xE9tel\xE9re",
      nl: "Laatste dagen om het pakket af te halen",
      no: "Siste dager for \xE5 hente pakken",
      pl: "Ostatnie dni na odbi\xF3r paczki",
      pt: "\xDAltimos dias para coletar o pacote",
      sk: "Posledn\xE9 dni na vyzdvihnutie bal\xEDka",
      sv: "Sista dagarna att h\xE4mta paketet"
    },
    internalDescription: {
      fr: "(Smart \u2013 J+5) Le colis ne restera encore disponible en point de retrait que pour une dur\xE9e tr\xE8s limit\xE9e ; le client doit imp\xE9rativement le r\xE9cup\xE9rer sans d\xE9lai.",
      en: "(Smart \u2013 D+5) The parcel will only remain available at the pickup point for a very limited time; the customer must collect it immediately.",
      de: "(Smart \u2013 T+5) Das Paket bleibt nur noch f\xFCr sehr begrenzte Zeit an der Abholstelle verf\xFCgbar; der Kunde muss es unverz\xFCglich abholen.",
      es: "(Smart \u2013 D+5) El paquete solo permanecer\xE1 disponible en el punto de recogida por un tiempo muy limitado; el cliente debe recogerlo inmediatamente.",
      it: "(Smart \u2013 G+5) Il pacco rimarr\xE0 disponibile presso il punto di ritiro solo per un tempo molto limitato; il cliente deve ritirarlo immediatamente."
    }
  },
  ["WAITING_INFORMATION_FROM_ADDRESS" /* WAITING_INFORMATION_FROM_ADDRESS */]: {
    internalTitle: {
      fr: "Informations compl\xE9mentaires requises",
      en: "Additional information required",
      de: "Zus\xE4tzliche Informationen erforderlich",
      es: "Informaci\xF3n adicional requerida",
      it: "Informazioni aggiuntive richieste"
    },
    title: {
      fr: "Informations requises pour la livraison",
      en: "Information required for delivery",
      de: "Informationen f\xFCr die Lieferung erforderlich",
      es: "Informaci\xF3n requerida para la entrega",
      it: "Informazioni richieste per la consegna",
      bg: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u0437\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
      cs: "Informace pot\u0159ebn\xE9 pro doru\u010Den\xED",
      da: "Oplysninger p\xE5kr\xE6vet for levering",
      fi: "Tietoja tarvitaan toimitukseen",
      hu: "Inform\xE1ci\xF3 sz\xFCks\xE9ges a k\xE9zbes\xEDt\xE9shez",
      nl: "Informatie vereist voor bezorging",
      no: "Informasjon kreves for levering",
      pl: "Informacje wymagane do dostawy",
      pt: "Informa\xE7\xF5es necess\xE1rias para entrega",
      sk: "Inform\xE1cie potrebn\xE9 na doru\u010Denie",
      sv: "Information kr\xE4vs f\xF6r leverans"
    },
    description: {
      fr: "Le transporteur a besoin d'informations",
      en: "The carrier needs information",
      de: "Der Spediteur ben\xF6tigt Informationen",
      es: "El transportista necesita informaci\xF3n",
      it: "Il corriere ha bisogno di informazioni",
      bg: "\u041F\u0440\u0435\u0432\u043E\u0437\u0432\u0430\u0447\u044A\u0442 \u0441\u0435 \u043D\u0443\u0436\u0434\u0430\u0435 \u043E\u0442 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F",
      cs: "Dopravce pot\u0159ebuje informace",
      da: "Transport\xF8ren har brug for oplysninger",
      fi: "Kuljettaja tarvitsee tietoja",
      hu: "A sz\xE1ll\xEDt\xF3 inform\xE1ci\xF3t ig\xE9nyel",
      nl: "De vervoerder heeft informatie nodig",
      no: "Transport\xF8ren trenger informasjon",
      pl: "Przewo\u017Anik potrzebuje informacji",
      pt: "A transportadora precisa de informa\xE7\xF5es",
      sk: "Dopravca potrebuje inform\xE1cie",
      sv: "Transport\xF6ren beh\xF6ver information"
    },
    internalDescription: {
      fr: "Le transporteur a besoin d'informations compl\xE9mentaires pour finaliser la livraison et contacte le client final.",
      en: "The carrier needs additional information to complete the delivery and is contacting the end customer.",
      de: "Der Spediteur ben\xF6tigt zus\xE4tzliche Informationen, um die Lieferung abzuschlie\xDFen, und kontaktiert den Endkunden.",
      es: "El transportista necesita informaci\xF3n adicional para completar la entrega y est\xE1 contactando al cliente final.",
      it: "Il corriere ha bisogno di informazioni aggiuntive per completare la consegna e sta contattando il cliente finale."
    }
  },
  ["DELIVERED_TO_NEIGHBOUR" /* DELIVERED_TO_NEIGHBOUR */]: {
    internalTitle: {
      fr: "Colis remis \xE0 un tiers autoris\xE9",
      en: "Parcel delivered to authorized third party",
      de: "Paket an autorisierten Dritten \xFCbergeben",
      es: "Paquete entregado a tercero autorizado",
      it: "Pacco consegnato a terza parte autorizzata"
    },
    title: {
      fr: "Colis remis \xE0 un voisin",
      en: "Parcel delivered to neighbour",
      de: "Paket an Nachbarn \xFCbergeben",
      es: "Paquete entregado a un vecino",
      it: "Pacco consegnato a un vicino",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430 \u043D\u0430 \u0441\u044A\u0441\u0435\u0434",
      cs: "Bal\xEDk doru\u010Den sousedovi",
      da: "Pakke leveret til nabo",
      fi: "Paketti toimitettu naapurille",
      hu: "Csomag szomsz\xE9dnak k\xE9zbes\xEDtve",
      nl: "Pakket bezorgd bij buur",
      no: "Pakke levert til nabo",
      pl: "Paczka dostarczona do s\u0105siada",
      pt: "Pacote entregue ao vizinho",
      sk: "Bal\xEDk doru\u010Den\xFD susedovi",
      sv: "Paket levererat till granne"
    },
    description: {
      fr: "Remis \xE0 un tiers autoris\xE9",
      en: "Delivered to authorized third party",
      de: "An autorisierten Dritten \xFCbergeben",
      es: "Entregado a tercero autorizado",
      it: "Consegnato a terza parte autorizzata",
      bg: "\u0414\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u043E \u043D\u0430 \u0443\u043F\u044A\u043B\u043D\u043E\u043C\u043E\u0449\u0435\u043D\u0430 \u0442\u0440\u0435\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0430",
      cs: "Doru\u010Deno opr\xE1vn\u011Bn\xE9 t\u0159et\xED stran\u011B",
      da: "Leveret til autoriseret tredjepart",
      fi: "Toimitettu valtuutetulle kolmannelle osapuolelle",
      hu: "Felhatalmazott harmadik f\xE9lnek k\xE9zbes\xEDtve",
      nl: "Bezorgd aan geautoriseerde derde partij",
      no: "Levert til autorisert tredjepart",
      pl: "Dostarczone upowa\u017Cnionej osobie trzeciej",
      pt: "Entregue a terceiro autorizado",
      sk: "Doru\u010Den\xE9 opr\xE1vnenej tretej strane",
      sv: "Levererat till auktoriserad tredje part"
    },
    internalDescription: {
      fr: "Le colis a \xE9t\xE9 remis \xE0 un tiers autoris\xE9 par le client, qui en a accus\xE9 r\xE9ception.",
      en: "The parcel has been delivered to an authorized third party who acknowledged receipt.",
      de: "Das Paket wurde an einen vom Kunden autorisierten Dritten \xFCbergeben, der den Empfang best\xE4tigt hat.",
      es: "El paquete ha sido entregado a un tercero autorizado por el cliente, quien acus\xF3 recibo.",
      it: "Il pacco \xE8 stato consegnato a una terza parte autorizzata dal cliente, che ne ha accusato ricevuta."
    }
  },
  ["DELIVERED" /* DELIVERED */]: {
    internalTitle: {
      fr: "Colis livr\xE9 au destinataire",
      en: "Parcel delivered to recipient",
      de: "Paket an Empf\xE4nger geliefert",
      es: "Paquete entregado al destinatario",
      it: "Pacco consegnato al destinatario"
    },
    title: {
      fr: "Colis livr\xE9",
      en: "Parcel delivered",
      de: "Paket geliefert",
      es: "Paquete entregado",
      it: "Pacco consegnato",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430",
      cs: "Bal\xEDk doru\u010Den",
      da: "Pakke leveret",
      fi: "Paketti toimitettu",
      hu: "Csomag k\xE9zbes\xEDtve",
      nl: "Pakket bezorgd",
      no: "Pakke levert",
      pl: "Paczka dostarczona",
      pt: "Pacote entregue",
      sk: "Bal\xEDk doru\u010Den\xFD",
      sv: "Paket levererat"
    },
    description: {
      fr: "Le colis a \xE9t\xE9 livr\xE9",
      en: "The parcel has been delivered",
      de: "Das Paket wurde geliefert",
      es: "El paquete ha sido entregado",
      it: "Il pacco \xE8 stato consegnato",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0430",
      cs: "Bal\xEDk byl doru\u010Den",
      da: "Pakken er blevet leveret",
      fi: "Paketti on toimitettu",
      hu: "A csomag k\xE9zbes\xEDtve lett",
      nl: "Het pakket is bezorgd",
      no: "Pakken er levert",
      pl: "Paczka zosta\u0142a dostarczona",
      pt: "O pacote foi entregue",
      sk: "Bal\xEDk bol doru\u010Den\xFD",
      sv: "Paketet har levererats"
    },
    internalDescription: {
      fr: "Le colis a \xE9t\xE9 livr\xE9 au destinataire, qui en a accus\xE9 r\xE9ception.",
      en: "The parcel has been delivered to the recipient who acknowledged receipt.",
      de: "Das Paket wurde an den Empf\xE4nger geliefert, der den Empfang best\xE4tigt hat.",
      es: "El paquete ha sido entregado al destinatario, quien acus\xF3 recibo.",
      it: "Il pacco \xE8 stato consegnato al destinatario, che ne ha accusato ricevuta."
    }
  },
  ["RETURNED_TO_SENDER" /* RETURNED_TO_SENDER */]: {
    internalTitle: {
      fr: "Colis retourn\xE9 \xE0 l'exp\xE9diteur",
      en: "Parcel returned to sender",
      de: "Paket an Absender zur\xFCckgesandt",
      es: "Paquete devuelto al remitente",
      it: "Pacco restituito al mittente"
    },
    title: {
      fr: "Colis retourn\xE9",
      en: "Parcel returned",
      de: "Paket zur\xFCckgesandt",
      es: "Paquete devuelto",
      it: "Pacco restituito",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430 \u0432\u044A\u0440\u043D\u0430\u0442\u0430",
      cs: "Bal\xEDk vr\xE1cen",
      da: "Pakke returneret",
      fi: "Paketti palautettu",
      hu: "Csomag visszak\xFCldve",
      nl: "Pakket teruggestuurd",
      no: "Pakke returnert",
      pl: "Paczka zwr\xF3cona",
      pt: "Pacote devolvido",
      sk: "Bal\xEDk vr\xE1ten\xFD",
      sv: "Paket returnerat"
    },
    description: {
      fr: "Le colis a \xE9t\xE9 retourn\xE9 \xE0 l'exp\xE9diteur",
      en: "The parcel has been returned to sender",
      de: "Das Paket wurde an den Absender zur\xFCckgesandt",
      es: "El paquete ha sido devuelto al remitente",
      it: "Il pacco \xE8 stato restituito al mittente",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0435 \u0432\u044A\u0440\u043D\u0430\u0442\u0430 \u043D\u0430 \u043F\u043E\u0434\u0430\u0442\u0435\u043B\u044F",
      cs: "Bal\xEDk byl vr\xE1cen odes\xEDlateli",
      da: "Pakken er blevet returneret til afsender",
      fi: "Paketti on palautettu l\xE4hett\xE4j\xE4lle",
      hu: "A csomag visszak\xFCld\xE9sre ker\xFClt a felad\xF3nak",
      nl: "Het pakket is teruggestuurd naar de afzender",
      no: "Pakken er returnert til avsender",
      pl: "Paczka zosta\u0142a zwr\xF3cona do nadawcy",
      pt: "O pacote foi devolvido ao remetente",
      sk: "Bal\xEDk bol vr\xE1ten\xFD odosielate\u013Eovi",
      sv: "Paketet har returnerats till avs\xE4ndaren"
    },
    internalDescription: {
      fr: "Le colis n'a pas pu \xEAtre livr\xE9 ou r\xE9cup\xE9r\xE9 en point de retrait ; il a \xE9t\xE9 retourn\xE9 \xE0 l'exp\xE9diteur.",
      en: "The parcel could not be delivered or collected at the pickup point; it has been returned to the sender.",
      de: "Das Paket konnte nicht geliefert oder an der Abholstelle abgeholt werden; es wurde an den Absender zur\xFCckgesandt.",
      es: "El paquete no pudo ser entregado o recogido en el punto de recogida; ha sido devuelto al remitente.",
      it: "Il pacco non ha potuto essere consegnato o ritirato al punto di ritiro; \xE8 stato restituito al mittente."
    }
  },
  ["EXCEPTION" /* EXCEPTION */]: {
    internalTitle: {
      fr: "Incident d'acheminement compromettant la livraison",
      en: "Routing incident compromising delivery",
      de: "Transportvorfall beeintr\xE4chtigt Lieferung",
      es: "Incidente de env\xEDo que compromete la entrega",
      it: "Incidente di trasporto che compromette la consegna"
    },
    title: {
      fr: "Incident de livraison",
      en: "Delivery incident",
      de: "Liefervorfall",
      es: "Incidente de entrega",
      it: "Incidente di consegna",
      bg: "\u0418\u043D\u0446\u0438\u0434\u0435\u043D\u0442 \u043F\u0440\u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
      cs: "Incident p\u0159i doru\u010Den\xED",
      da: "Leveringsincident",
      fi: "Toimitush\xE4iri\xF6",
      hu: "K\xE9zbes\xEDt\xE9si incidens",
      nl: "Bezorgincident",
      no: "Leveringshendelse",
      pl: "Incydent dostawy",
      pt: "Incidente de entrega",
      sk: "Incident pri doru\u010Den\xED",
      sv: "Leveransincident"
    },
    description: {
      fr: "Un incident d'acheminement a \xE9t\xE9 signal\xE9",
      en: "A routing incident has been reported",
      de: "Ein Transportvorfall wurde gemeldet",
      es: "Se ha reportado un incidente de env\xEDo",
      it: "\xC8 stato segnalato un incidente di trasporto",
      bg: "\u0421\u044A\u043E\u0431\u0449\u0435\u043D\u043E \u0435 \u0437\u0430 \u0438\u043D\u0446\u0438\u0434\u0435\u043D\u0442 \u043F\u0440\u0438 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0438\u0440\u0430\u043D\u0435",
      cs: "Byla nahl\xE1\u0161ena dopravn\xED nehoda",
      da: "En transportbegivenhed er blevet rapporteret",
      fi: "Kuljetush\xE4iri\xF6 on raportoitu",
      hu: "Sz\xE1ll\xEDt\xE1si incidens jelentve",
      nl: "Een transportincident is gemeld",
      no: "En transporthendelseble er rapportert",
      pl: "Zg\u0142oszono incydent transportowy",
      pt: "Um incidente de transporte foi reportado",
      sk: "Bola nahl\xE1sen\xE1 dopravn\xE1 udalos\u0165",
      sv: "En transportincident har rapporterats"
    },
    internalDescription: {
      fr: "(Ticket SAV \xE0 envisager) Le transporteur signale un incident d'acheminement compromettant la livraison ; le marchand est invit\xE9 \xE0 engager une action corrective.",
      en: "(Consider support ticket) The carrier reports a routing incident compromising delivery; the merchant is invited to take corrective action.",
      de: "(Support-Ticket erw\xE4gen) Der Spediteur meldet einen Transportvorfall, der die Lieferung beeintr\xE4chtigt; der H\xE4ndler wird gebeten, Korrekturma\xDFnahmen einzuleiten.",
      es: "(Considerar ticket de soporte) El transportista reporta un incidente de env\xEDo que compromete la entrega; se invita al comerciante a tomar medidas correctivas.",
      it: "(Considerare ticket di supporto) Il corriere segnala un incidente di trasporto che compromette la consegna; il commerciante \xE8 invitato a prendere provvedimenti correttivi."
    }
  },
  ["OUT_FOR_DELIVERY" /* OUT_FOR_DELIVERY */]: {
    internalTitle: {
      fr: "Livraison pr\xE9vue aujourd'hui",
      en: "Delivery scheduled for today",
      de: "Lieferung f\xFCr heute geplant",
      es: "Entrega programada para hoy",
      it: "Consegna prevista per oggi"
    },
    title: {
      fr: "Livraison en cours",
      en: "Out for delivery",
      de: "Unterwegs zur Zustellung",
      es: "En camino para entrega",
      it: "In consegna",
      bg: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441 \u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
      cs: "Na cest\u011B k doru\u010Den\xED",
      da: "Ude til levering",
      fi: "Kuljetuksessa",
      hu: "Kisz\xE1ll\xEDt\xE1s alatt",
      nl: "Onderweg voor bezorging",
      no: "Ute for levering",
      pl: "W trakcie dostawy",
      pt: "Saiu para entrega",
      sk: "Na ceste k doru\u010Deniu",
      sv: "Ute f\xF6r leverans"
    },
    description: {
      fr: "Le colis est en cours de livraison",
      en: "The parcel is out for delivery",
      de: "Das Paket ist unterwegs zur Zustellung",
      es: "El paquete est\xE1 en camino para entrega",
      it: "Il pacco \xE8 in consegna",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0435 \u0432 \u043F\u0440\u043E\u0446\u0435\u0441 \u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
      cs: "Bal\xEDk je na cest\u011B k doru\u010Den\xED",
      da: "Pakken er ude til levering",
      fi: "Paketti on kuljetuksessa",
      hu: "A csomag kisz\xE1ll\xEDt\xE1s alatt van",
      nl: "Het pakket is onderweg voor bezorging",
      no: "Pakken er ute for levering",
      pl: "Paczka jest w trakcie dostawy",
      pt: "O pacote saiu para entrega",
      sk: "Bal\xEDk je na ceste k doru\u010Deniu",
      sv: "Paketet \xE4r ute f\xF6r leverans"
    },
    internalDescription: {
      fr: "La livraison est planifi\xE9e pour aujourd'hui ; le colis est en phase de dernier kilom\xE8tre.",
      en: "Delivery is scheduled for today; the parcel is in the last mile phase.",
      de: "Die Lieferung ist f\xFCr heute geplant; das Paket befindet sich in der letzten Meile.",
      es: "La entrega est\xE1 programada para hoy; el paquete est\xE1 en la fase de \xFAltima milla.",
      it: "La consegna \xE8 prevista per oggi; il pacco \xE8 nella fase di ultimo miglio."
    }
  },
  ["DELIVERY_ATTEMPTED" /* DELIVERY_ATTEMPTED */]: {
    internalTitle: {
      fr: "Premi\xE8re tentative de livraison \xE9chou\xE9e",
      en: "First delivery attempt failed",
      de: "Erster Zustellversuch fehlgeschlagen",
      es: "Primer intento de entrega fallido",
      it: "Primo tentativo di consegna fallito"
    },
    title: {
      fr: "Tentative de livraison \xE9chou\xE9e",
      en: "Delivery attempt failed",
      de: "Zustellversuch fehlgeschlagen",
      es: "Intento de entrega fallido",
      it: "Tentativo di consegna fallito",
      bg: "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u0435\u043D \u043E\u043F\u0438\u0442 \u0437\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
      cs: "Pokus o doru\u010Den\xED selhal",
      da: "Leveringsfors\xF8g mislykkedes",
      fi: "Toimitusyritys ep\xE4onnistui",
      hu: "Sikertelen k\xE9zbes\xEDt\xE9si k\xEDs\xE9rlet",
      nl: "Bezorgpoging mislukt",
      no: "Leveringsfors\xF8k mislyktes",
      pl: "Pr\xF3ba dostawy nie powiod\u0142a si\u0119",
      pt: "Tentativa de entrega falhou",
      sk: "Pokus o doru\u010Denie zlyhal",
      sv: "Leveransf\xF6rs\xF6k misslyckades"
    },
    description: {
      fr: "Une tentative de livraison a \xE9chou\xE9",
      en: "A delivery attempt has failed",
      de: "Ein Zustellversuch ist fehlgeschlagen",
      es: "Un intento de entrega ha fallado",
      it: "Un tentativo di consegna \xE8 fallito",
      bg: "\u041E\u043F\u0438\u0442 \u0437\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u0435 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u0435\u043D",
      cs: "Pokus o doru\u010Den\xED selhal",
      da: "Et leveringsfors\xF8g er mislykkedes",
      fi: "Toimitusyritys on ep\xE4onnistunut",
      hu: "Egy k\xE9zbes\xEDt\xE9si k\xEDs\xE9rlet sikertelen volt",
      nl: "Een bezorgpoging is mislukt",
      no: "Et leveringsfors\xF8k har mislyktes",
      pl: "Pr\xF3ba dostawy nie powiod\u0142a si\u0119",
      pt: "Uma tentativa de entrega falhou",
      sk: "Pokus o doru\u010Denie zlyhal",
      sv: "Ett leveransf\xF6rs\xF6k har misslyckats"
    },
    internalDescription: {
      fr: "La tourn\xE9e de livraison a eu lieu mais la remise n'a pas pu \xEAtre effectu\xE9e ; une nouvelle tentative de livraison est pr\xE9vue.",
      en: "The delivery round took place but the handover could not be completed; a new delivery attempt is scheduled.",
      de: "Die Zustelltour fand statt, aber die \xDCbergabe konnte nicht abgeschlossen werden; ein neuer Zustellversuch ist geplant.",
      es: "La ronda de entrega tuvo lugar pero la entrega no pudo completarse; se ha programado un nuevo intento de entrega.",
      it: "Il giro di consegna \xE8 avvenuto ma la consegna non ha potuto essere completata; \xE8 previsto un nuovo tentativo di consegna."
    }
  },
  ["COLLECTED_AT_PICKUP" /* COLLECTED_AT_PICKUP */]: {
    internalTitle: {
      fr: "Colis r\xE9cup\xE9r\xE9 par le client",
      en: "Parcel collected by customer",
      de: "Paket vom Kunden abgeholt",
      es: "Paquete recogido por el cliente",
      it: "Pacco ritirato dal cliente"
    },
    title: {
      fr: "Colis r\xE9cup\xE9r\xE9",
      en: "Parcel collected",
      de: "Paket abgeholt",
      es: "Paquete recogido",
      it: "Pacco ritirato",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0430",
      cs: "Bal\xEDk vyzvednut",
      da: "Pakke afhentet",
      fi: "Paketti noudettu",
      hu: "Csomag \xE1tv\xE9ve",
      nl: "Pakket opgehaald",
      no: "Pakke hentet",
      pl: "Paczka odebrana",
      pt: "Pacote coletado",
      sk: "Bal\xEDk vyzdvihnut\xFD",
      sv: "Paket upph\xE4mtat"
    },
    description: {
      fr: "Le colis a \xE9t\xE9 r\xE9cup\xE9r\xE9 en point de retrait",
      en: "The parcel has been collected at pickup point",
      de: "Das Paket wurde an der Abholstelle abgeholt",
      es: "El paquete ha sido recogido en el punto de recogida",
      it: "Il pacco \xE8 stato ritirato al punto di ritiro",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0430 \u043E\u0442 \u043F\u0443\u043D\u043A\u0442\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435",
      cs: "Bal\xEDk byl vyzvednut na v\xFDdejn\xEDm m\xEDst\u011B",
      da: "Pakken er blevet afhentet p\xE5 afhentningsstedet",
      fi: "Paketti on noudettu noutopisteest\xE4",
      hu: "A csomag \xE1t lett v\xE9ve az \xE1tv\xE9teli ponton",
      nl: "Het pakket is opgehaald bij het afhaalpunt",
      no: "Pakken er hentet fra hentepunktet",
      pl: "Paczka zosta\u0142a odebrana z punktu odbioru",
      pt: "O pacote foi coletado no ponto de coleta",
      sk: "Bal\xEDk bol vyzdvihnut\xFD na v\xFDdajnom mieste",
      sv: "Paketet har h\xE4mtats p\xE5 upph\xE4mtningsst\xE4llet"
    },
    internalDescription: {
      fr: "Le colis a \xE9t\xE9 r\xE9cup\xE9r\xE9 en point de retrait par le client.",
      en: "The parcel has been collected at the pickup point by the customer.",
      de: "Das Paket wurde vom Kunden an der Abholstelle abgeholt.",
      es: "El paquete ha sido recogido en el punto de recogida por el cliente.",
      it: "Il pacco \xE8 stato ritirato al punto di ritiro dal cliente."
    }
  },
  ["DELAYED_PACKAGE" /* DELAYED_PACKAGE */]: {
    internalTitle: {
      fr: "Retard mod\xE9r\xE9 d\xE9tect\xE9",
      en: "Moderate delay detected",
      de: "M\xE4\xDFige Verz\xF6gerung erkannt",
      es: "Retraso moderado detectado",
      it: "Ritardo moderato rilevato"
    },
    title: {
      fr: "Colis retard\xE9",
      en: "Parcel delayed",
      de: "Paket verz\xF6gert",
      es: "Paquete retrasado",
      it: "Pacco in ritardo",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430 \u0441\u044A\u0441 \u0437\u0430\u0431\u0430\u0432\u044F\u043D\u0435",
      cs: "Bal\xEDk zpo\u017Ed\u011Bn",
      da: "Pakke forsinket",
      fi: "Paketti viiv\xE4stynyt",
      hu: "Csomag k\xE9sik",
      nl: "Pakket vertraagd",
      no: "Pakke forsinket",
      pl: "Paczka op\xF3\u017Aniona",
      pt: "Pacote atrasado",
      sk: "Bal\xEDk oneskoren\xFD",
      sv: "Paket f\xF6rsenat"
    },
    description: {
      fr: "Un retard mod\xE9r\xE9 a \xE9t\xE9 d\xE9tect\xE9",
      en: "A moderate delay has been detected",
      de: "Eine m\xE4\xDFige Verz\xF6gerung wurde erkannt",
      es: "Se ha detectado un retraso moderado",
      it: "\xC8 stato rilevato un ritardo moderato",
      bg: "\u041E\u0442\u043A\u0440\u0438\u0442\u043E \u0435 \u0443\u043C\u0435\u0440\u0435\u043D\u043E \u0437\u0430\u0431\u0430\u0432\u044F\u043D\u0435",
      cs: "Bylo zji\u0161t\u011Bno m\xEDrn\xE9 zpo\u017Ed\u011Bn\xED",
      da: "En moderat forsinkelse er blevet opdaget",
      fi: "Kohtalainen viive on havaittu",
      hu: "M\xE9rs\xE9kelt k\xE9s\xE9s \xE9szlelve",
      nl: "Een matige vertraging is gedetecteerd",
      no: "En moderat forsinkelse er oppdaget",
      pl: "Wykryto umiarkowane op\xF3\u017Anienie",
      pt: "Um atraso moderado foi detectado",
      sk: "Bolo zisten\xE9 mierne oneskorenie",
      sv: "En m\xE5ttlig f\xF6rsening har uppt\xE4ckts"
    },
    internalDescription: {
      fr: "(Smart \u2013 J+3) Une difficult\xE9 a \xE9t\xE9 identifi\xE9e au cours de l'acheminement ; un retard mod\xE9r\xE9 par rapport \xE0 la date de livraison initiale est probable.",
      en: "(Smart \u2013 D+3) A difficulty has been identified during transit; a moderate delay compared to the initial delivery date is likely.",
      de: "(Smart \u2013 T+3) W\xE4hrend des Transports wurde eine Schwierigkeit festgestellt; eine m\xE4\xDFige Verz\xF6gerung gegen\xFCber dem urspr\xFCnglichen Lieferdatum ist wahrscheinlich.",
      es: "(Smart \u2013 D+3) Se ha identificado una dificultad durante el tr\xE1nsito; es probable un retraso moderado respecto a la fecha de entrega inicial.",
      it: "(Smart \u2013 G+3) \xC8 stata identificata una difficolt\xE0 durante il transito; \xE8 probabile un ritardo moderato rispetto alla data di consegna iniziale."
    }
  },
  ["CUSTOMS_CLEARANCE_START" /* CUSTOMS_CLEARANCE_START */]: {
    internalTitle: {
      fr: "Incident douanier d\xE9clar\xE9",
      en: "Customs incident declared",
      de: "Zollvorfall gemeldet",
      es: "Incidente aduanero declarado",
      it: "Incidente doganale dichiarato"
    },
    title: {
      fr: "Colis en douane",
      en: "Parcel in customs",
      de: "Paket beim Zoll",
      es: "Paquete en aduanas",
      it: "Pacco in dogana",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430 \u043D\u0430 \u043C\u0438\u0442\u043D\u0438\u0446\u0430",
      cs: "Bal\xEDk v celn\xEDm \u0159\xEDzen\xED",
      da: "Pakke i tolden",
      fi: "Paketti tullissa",
      hu: "Csomag v\xE1mon",
      nl: "Pakket bij de douane",
      no: "Pakke i tollen",
      pl: "Paczka w urz\u0119dzie celnym",
      pt: "Pacote na alf\xE2ndega",
      sk: "Bal\xEDk na colnici",
      sv: "Paket i tullen"
    },
    description: {
      fr: "Le colis est bloqu\xE9 en douane",
      en: "The parcel is held in customs",
      de: "Das Paket wird beim Zoll festgehalten",
      es: "El paquete est\xE1 retenido en aduanas",
      it: "Il pacco \xE8 trattenuto in dogana",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0435 \u0437\u0430\u0434\u044A\u0440\u0436\u0430\u043D\u0430 \u043D\u0430 \u043C\u0438\u0442\u043D\u0438\u0446\u0430",
      cs: "Bal\xEDk je zadr\u017Een na celnici",
      da: "Pakken holdes tilbage i tolden",
      fi: "Paketti on pid\xE4tetty tullissa",
      hu: "A csomagot a v\xE1mon tartj\xE1k",
      nl: "Het pakket wordt bij de douane vastgehouden",
      no: "Pakken holdes tilbake i tollen",
      pl: "Paczka jest zatrzymana na urz\u0119dzie celnym",
      pt: "O pacote est\xE1 retido na alf\xE2ndega",
      sk: "Bal\xEDk je zadr\u017Ean\xFD na colnici",
      sv: "Paketet h\xE5lls kvar i tullen"
    },
    internalDescription: {
      fr: "(Ticket SAV \xE0 envisager) Le transporteur signale une difficult\xE9 douani\xE8re affectant l'acheminement ; le client final a \xE9t\xE9 inform\xE9.",
      en: "(Consider support ticket) The carrier reports a customs difficulty affecting transit; the end customer has been informed.",
      de: "(Support-Ticket erw\xE4gen) Der Spediteur meldet eine Zollschwierigkeit, die den Transport beeintr\xE4chtigt; der Endkunde wurde informiert.",
      es: "(Considerar ticket de soporte) El transportista reporta una dificultad aduanera que afecta el tr\xE1nsito; el cliente final ha sido informado.",
      it: "(Considerare ticket di supporto) Il corriere segnala una difficolt\xE0 doganale che influisce sul transito; il cliente finale \xE8 stato informato."
    }
  },
  ["CUSTOMS_CLEARANCE_COMPLETE" /* CUSTOMS_CLEARANCE_COMPLETE */]: {
    internalTitle: {
      fr: "Proc\xE9dure douani\xE8re termin\xE9e",
      en: "Customs procedure completed",
      de: "Zollverfahren abgeschlossen",
      es: "Procedimiento aduanero completado",
      it: "Procedura doganale completata"
    },
    title: {
      fr: "D\xE9douanement effectu\xE9",
      en: "Customs cleared",
      de: "Zollabfertigung erfolgt",
      es: "Despacho de aduanas completado",
      it: "Sdoganamento effettuato",
      bg: "\u041C\u0438\u0442\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0442\u043E \u043E\u0444\u043E\u0440\u043C\u044F\u043D\u0435 \u043F\u0440\u0438\u043A\u043B\u044E\u0447\u0438",
      cs: "Celn\xED \u0159\xEDzen\xED dokon\u010Deno",
      da: "Toldbehandling afsluttet",
      fi: "Tulliselvitys valmis",
      hu: "V\xE1mkezel\xE9s k\xE9sz",
      nl: "Douane afgehandeld",
      no: "Tollbehandling fullf\xF8rt",
      pl: "Odprawa celna zako\u0144czona",
      pt: "Desalfandegamento conclu\xEDdo",
      sk: "Coln\xE9 konanie dokon\u010Den\xE9",
      sv: "Tullklarering klar"
    },
    description: {
      fr: "La proc\xE9dure douani\xE8re est finalis\xE9e",
      en: "The customs procedure is finalized",
      de: "Das Zollverfahren ist abgeschlossen",
      es: "El procedimiento aduanero est\xE1 finalizado",
      it: "La procedura doganale \xE8 finalizzata",
      bg: "\u041C\u0438\u0442\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u0442\u0430 \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430 \u0435 \u043F\u0440\u0438\u043A\u043B\u044E\u0447\u0438\u043B\u0430",
      cs: "Celn\xED \u0159\xEDzen\xED je dokon\u010Deno",
      da: "Toldproceduren er afsluttet",
      fi: "Tulliselvitys on valmis",
      hu: "A v\xE1melj\xE1r\xE1s befejez\u0151d\xF6tt",
      nl: "De douaneprocedure is afgerond",
      no: "Tollprosedyren er fullf\xF8rt",
      pl: "Procedura celna zosta\u0142a zako\u0144czona",
      pt: "O procedimento alfandeg\xE1rio foi finalizado",
      sk: "Coln\xE9 konanie je dokon\u010Den\xE9",
      sv: "Tullproceduren \xE4r avslutad"
    },
    internalDescription: {
      fr: "La proc\xE9dure douani\xE8re est finalis\xE9e ; le colis reprend son acheminement.",
      en: "The customs procedure is finalized; the parcel resumes transit.",
      de: "Das Zollverfahren ist abgeschlossen; das Paket setzt seinen Transport fort.",
      es: "El procedimiento aduanero est\xE1 finalizado; el paquete reanuda su tr\xE1nsito.",
      it: "La procedura doganale \xE8 finalizzata; il pacco riprende il transito."
    }
  },
  ["DELAYED_PACKAGE_SEVERE" /* DELAYED_PACKAGE_SEVERE */]: {
    internalTitle: {
      fr: "Retard important d\xE9tect\xE9",
      en: "Significant delay detected",
      de: "Erhebliche Verz\xF6gerung erkannt",
      es: "Retraso significativo detectado",
      it: "Ritardo significativo rilevato"
    },
    title: {
      fr: "Retard important",
      en: "Significant delay",
      de: "Erhebliche Verz\xF6gerung",
      es: "Retraso significativo",
      it: "Ritardo significativo",
      bg: "\u0417\u043D\u0430\u0447\u0438\u0442\u0435\u043B\u043D\u043E \u0437\u0430\u0431\u0430\u0432\u044F\u043D\u0435",
      cs: "V\xFDznamn\xE9 zpo\u017Ed\u011Bn\xED",
      da: "Betydelig forsinkelse",
      fi: "Merkitt\xE4v\xE4 viive",
      hu: "Jelent\u0151s k\xE9s\xE9s",
      nl: "Aanzienlijke vertraging",
      no: "Betydelig forsinkelse",
      pl: "Znaczne op\xF3\u017Anienie",
      pt: "Atraso significativo",
      sk: "V\xFDznamn\xE9 oneskorenie",
      sv: "Betydande f\xF6rsening"
    },
    description: {
      fr: "Un retard important a \xE9t\xE9 d\xE9tect\xE9",
      en: "A significant delay has been detected",
      de: "Eine erhebliche Verz\xF6gerung wurde erkannt",
      es: "Se ha detectado un retraso significativo",
      it: "\xC8 stato rilevato un ritardo significativo",
      bg: "\u041E\u0442\u043A\u0440\u0438\u0442\u043E \u0435 \u0437\u043D\u0430\u0447\u0438\u0442\u0435\u043B\u043D\u043E \u0437\u0430\u0431\u0430\u0432\u044F\u043D\u0435",
      cs: "Bylo zji\u0161t\u011Bno v\xFDznamn\xE9 zpo\u017Ed\u011Bn\xED",
      da: "En betydelig forsinkelse er blevet opdaget",
      fi: "Merkitt\xE4v\xE4 viive on havaittu",
      hu: "Jelent\u0151s k\xE9s\xE9s \xE9szlelve",
      nl: "Een aanzienlijke vertraging is gedetecteerd",
      no: "En betydelig forsinkelse er oppdaget",
      pl: "Wykryto znaczne op\xF3\u017Anienie",
      pt: "Um atraso significativo foi detectado",
      sk: "Bolo zisten\xE9 v\xFDznamn\xE9 oneskorenie",
      sv: "En betydande f\xF6rsening har uppt\xE4ckts"
    },
    internalDescription: {
      fr: "(Smart \u2013 J+5) Une difficult\xE9 notable perturbe l'acheminement ; un retard important par rapport \xE0 la date de livraison initiale est probable.",
      en: "(Smart \u2013 D+5) A notable difficulty is disrupting transit; a significant delay compared to the initial delivery date is likely.",
      de: "(Smart \u2013 T+5) Eine bemerkenswerte Schwierigkeit st\xF6rt den Transport; eine erhebliche Verz\xF6gerung gegen\xFCber dem urspr\xFCnglichen Lieferdatum ist wahrscheinlich.",
      es: "(Smart \u2013 D+5) Una dificultad notable est\xE1 interrumpiendo el tr\xE1nsito; es probable un retraso significativo respecto a la fecha de entrega inicial.",
      it: "(Smart \u2013 G+5) Una difficolt\xE0 notevole sta disturbando il transito; \xE8 probabile un ritardo significativo rispetto alla data di consegna iniziale."
    }
  },
  ["CARRIER_DELAYED_PACKAGE" /* CARRIER_DELAYED_PACKAGE */]: {
    internalTitle: {
      fr: "Colis retard\xE9 par le transporteur",
      en: "Parcel delayed by carrier",
      de: "Paket vom Spediteur verz\xF6gert",
      es: "Paquete retrasado por el transportista",
      it: "Pacco ritardato dal corriere"
    },
    title: {
      fr: "Colis retard\xE9",
      en: "Parcel delayed",
      de: "Paket verz\xF6gert",
      es: "Paquete retrasado",
      it: "Pacco in ritardo",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430 \u0441\u044A\u0441 \u0437\u0430\u0431\u0430\u0432\u044F\u043D\u0435",
      cs: "Bal\xEDk zpo\u017Ed\u011Bn",
      da: "Pakke forsinket",
      fi: "Paketti viiv\xE4stynyt",
      hu: "Csomag k\xE9sik",
      nl: "Pakket vertraagd",
      no: "Pakke forsinket",
      pl: "Paczka op\xF3\u017Aniona",
      pt: "Pacote atrasado",
      sk: "Bal\xEDk oneskoren\xFD",
      sv: "Paket f\xF6rsenat"
    },
    description: {
      fr: "Retard signal\xE9 par le transporteur",
      en: "Delay reported by carrier",
      de: "Verz\xF6gerung vom Spediteur gemeldet",
      es: "Retraso reportado por el transportista",
      it: "Ritardo segnalato dal corriere",
      bg: "\u0417\u0430\u0431\u0430\u0432\u044F\u043D\u0435, \u0441\u044A\u043E\u0431\u0449\u0435\u043D\u043E \u043E\u0442 \u043F\u0440\u0435\u0432\u043E\u0437\u0432\u0430\u0447\u0430",
      cs: "Zpo\u017Ed\u011Bn\xED nahl\xE1\u0161eno dopravcem",
      da: "Forsinkelse rapporteret af transport\xF8r",
      fi: "Kuljettaja ilmoitti viiveest\xE4",
      hu: "K\xE9s\xE9st jelentett a sz\xE1ll\xEDt\xF3",
      nl: "Vertraging gemeld door vervoerder",
      no: "Forsinkelse rapportert av transport\xF8r",
      pl: "Op\xF3\u017Anienie zg\u0142oszone przez przewo\u017Anika",
      pt: "Atraso reportado pela transportadora",
      sk: "Oneskorenie nahl\xE1sen\xE9 dopravcom",
      sv: "F\xF6rsening rapporterad av transport\xF6r"
    },
    internalDescription: {
      fr: "Retard constat\xE9 sans cause identifi\xE9e par le transporteur.",
      en: "Delay noted without cause identified by the carrier.",
      de: "Verz\xF6gerung festgestellt ohne vom Spediteur identifizierte Ursache.",
      es: "Retraso detectado sin causa identificada por el transportista.",
      it: "Ritardo rilevato senza causa identificata dal corriere."
    }
  },
  ["DISPATCHED_TO_OTHER_PICKUP_POINT" /* DISPATCHED_TO_OTHER_PICKUP_POINT */]: {
    internalTitle: {
      fr: "Colis livr\xE9 dans un autre point de retrait",
      en: "Parcel delivered to another pickup point",
      de: "Paket an andere Abholstelle geliefert",
      es: "Paquete entregado a otro punto de recogida",
      it: "Pacco consegnato a un altro punto di ritiro"
    },
    title: {
      fr: "Colis redirig\xE9 vers un autre point relais",
      en: "Parcel redirected to another pickup point",
      de: "Paket an andere Abholstelle umgeleitet",
      es: "Paquete redirigido a otro punto de recogida",
      it: "Pacco reindirizzato a un altro punto di ritiro",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430 \u043F\u0440\u0435\u043D\u0430\u0441\u043E\u0447\u0435\u043D\u0430 \u043A\u044A\u043C \u0434\u0440\u0443\u0433 \u043F\u0443\u043D\u043A\u0442 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435",
      cs: "Bal\xEDk p\u0159esm\u011Brov\xE1n na jin\xE9 v\xFDdejn\xED m\xEDsto",
      da: "Pakke omdirigeret til et andet afhentningssted",
      fi: "Paketti ohjattu toiseen noutopisteeseen",
      hu: "Csomag \xE1tir\xE1ny\xEDtva m\xE1sik \xE1tv\xE9teli pontra",
      nl: "Pakket omgeleid naar een ander afhaalpunt",
      no: "Pakke omdirigert til et annet hentepunkt",
      pl: "Paczka przekierowana do innego punktu odbioru",
      pt: "Pacote redirecionado para outro ponto de coleta",
      sk: "Bal\xEDk presmerovan\xFD na in\xE9 v\xFDdajn\xE9 miesto",
      sv: "Paket omdirigerat till ett annat upph\xE4mtningsst\xE4lle"
    },
    description: {
      fr: "Le colis a \xE9t\xE9 redirig\xE9 vers un autre point de retrait",
      en: "The parcel has been redirected to another pickup point",
      de: "Das Paket wurde an eine andere Abholstelle umgeleitet",
      es: "El paquete ha sido redirigido a otro punto de recogida",
      it: "Il pacco \xE8 stato reindirizzato a un altro punto di ritiro",
      bg: "\u041F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u0435 \u043F\u0440\u0435\u043D\u0430\u0441\u043E\u0447\u0435\u043D\u0430 \u043A\u044A\u043C \u0434\u0440\u0443\u0433 \u043F\u0443\u043D\u043A\u0442 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435",
      cs: "Bal\xEDk byl p\u0159esm\u011Brov\xE1n na jin\xE9 v\xFDdejn\xED m\xEDsto",
      da: "Pakken er blevet omdirigeret til et andet afhentningssted",
      fi: "Paketti on ohjattu toiseen noutopisteeseen",
      hu: "A csomag \xE1tir\xE1ny\xEDt\xE1sra ker\xFClt m\xE1sik \xE1tv\xE9teli pontra",
      nl: "Het pakket is omgeleid naar een ander afhaalpunt",
      no: "Pakken er omdirigert til et annet hentepunkt",
      pl: "Paczka zosta\u0142a przekierowana do innego punktu odbioru",
      pt: "O pacote foi redirecionado para outro ponto de coleta",
      sk: "Bal\xEDk bol presmerovan\xFD na in\xE9 v\xFDdajn\xE9 miesto",
      sv: "Paketet har omdirigerats till ett annat upph\xE4mtningsst\xE4lle"
    },
    internalDescription: {
      fr: "Le colis n'a pas pu \xEAtre d\xE9pos\xE9 dans le point de retrait initialement pr\xE9vu ; il a \xE9t\xE9 redirig\xE9 vers un autre point de retrait.",
      en: "The parcel could not be dropped at the initially planned pickup point; it has been redirected to another pickup point.",
      de: "Das Paket konnte nicht an der urspr\xFCnglich geplanten Abholstelle abgegeben werden; es wurde an eine andere Abholstelle umgeleitet.",
      es: "El paquete no pudo ser dejado en el punto de recogida inicialmente previsto; ha sido redirigido a otro punto de recogida.",
      it: "Il pacco non ha potuto essere lasciato al punto di ritiro inizialmente previsto; \xE8 stato reindirizzato a un altro punto di ritiro."
    }
  },
  ["STALE" /* STALE */]: {
    internalTitle: {
      fr: "Colis sans mise \xE0 jour prolong\xE9e",
      en: "Parcel with no update for an extended period",
      de: "Paket ohne Aktualisierung seit l\xE4ngerem",
      es: "Paquete sin actualizaci\xF3n durante un per\xEDodo prolongado",
      it: "Pacco senza aggiornamenti da un periodo prolungato"
    },
    title: {
      fr: "Colis sans nouvelles",
      en: "No parcel update",
      de: "Keine Paketaktualisierung",
      es: "Sin actualizaci\xF3n del paquete",
      it: "Nessun aggiornamento sul pacco",
      bg: "\u041D\u044F\u043C\u0430 \u0430\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F \u043D\u0430 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430",
      cs: "\u017D\xE1dn\xE1 aktualizace bal\xEDku",
      da: "Ingen pakkeopdatering",
      fi: "Ei pakettip\xE4ivityst\xE4",
      hu: "Nincs csomagfriss\xEDt\xE9s",
      nl: "Geen pakketupdate",
      no: "Ingen pakkeoppdatering",
      pl: "Brak aktualizacji paczki",
      pt: "Sem atualiza\xE7\xE3o do pacote",
      sk: "\u017Diadna aktualiz\xE1cia bal\xEDka",
      sv: "Ingen paketuppdatering"
    },
    description: {
      fr: "Aucune mise \xE0 jour du colis depuis un certain temps",
      en: "No parcel update for a while",
      de: "Seit einiger Zeit keine Paketaktualisierung",
      es: "Sin actualizaci\xF3n del paquete desde hace un tiempo",
      it: "Nessun aggiornamento del pacco da un po' di tempo",
      bg: "\u041D\u044F\u043C\u0430 \u0430\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F \u043D\u0430 \u043F\u0440\u0430\u0442\u043A\u0430\u0442\u0430 \u043E\u0442 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E \u0432\u0440\u0435\u043C\u0435",
      cs: "\u017D\xE1dn\xE1 aktualizace bal\xEDku po ur\u010Ditou dobu",
      da: "Ingen pakkeopdatering i et stykke tid",
      fi: "Pakettip\xE4ivityst\xE4 ei ole tullut v\xE4h\xE4\xE4n aikaan",
      hu: "Egy ideje nincs csomagfriss\xEDt\xE9s",
      nl: "Al een tijdje geen pakketupdate",
      no: "Ingen pakkeoppdatering p\xE5 en stund",
      pl: "Brak aktualizacji paczki od pewnego czasu",
      pt: "Sem atualiza\xE7\xE3o do pacote h\xE1 algum tempo",
      sk: "\u017Diadna aktualiz\xE1cia bal\xEDka u\u017E nejak\xFD \u010Das",
      sv: "Ingen paketuppdatering p\xE5 ett tag"
    },
    internalDescription: {
      fr: "(Smart) Le colis n'a re\xE7u aucune mise \xE0 jour de statut depuis une p\xE9riode prolong\xE9e ; une intervention peut \xEAtre n\xE9cessaire.",
      en: "(Smart) The parcel has received no status update for an extended period; intervention may be required.",
      de: "(Smart) Das Paket hat seit einem l\xE4ngeren Zeitraum keine Statusaktualisierung erhalten; ein Eingreifen kann erforderlich sein.",
      es: "(Smart) El paquete no ha recibido ninguna actualizaci\xF3n de estado durante un per\xEDodo prolongado; puede ser necesaria una intervenci\xF3n.",
      it: "(Smart) Il pacco non ha ricevuto alcun aggiornamento di stato per un periodo prolungato; potrebbe essere necessario un intervento."
    }
  }
};
function getTrackingStatusTranslation(status, locale) {
  const entry = TrackingStatusTranslations[status];
  const cleanLocale = (locale || "").split("-")[0].split("_")[0];
  const fallbackLocale = "en";
  const internalLoc = SUPPORTED_LOCALES.includes(cleanLocale) ? cleanLocale : fallbackLocale;
  const customerLoc = CUSTOMER_SUPPORTED_LOCALES.includes(
    cleanLocale
  ) ? cleanLocale : fallbackLocale;
  return {
    title: entry.title[customerLoc] ?? entry.title[fallbackLocale],
    description: entry.description[customerLoc] ?? entry.description[fallbackLocale],
    internalTitle: entry.internalTitle[internalLoc] ?? entry.internalTitle[fallbackLocale],
    internalDescription: entry.internalDescription[internalLoc] ?? entry.internalDescription[fallbackLocale]
  };
}

// src/klaviyo-workflow.ts
var KLAVIYO_DEFAULT_METRIC_NAME = "Baback - Tracking Update";

export { ALL_TRACKING_STATUSES, CUSTOMER_SUPPORTED_LOCALES, KLAVIYO_DEFAULT_METRIC_NAME, SUPPORTED_LOCALES, TRACKING_STATUS_CATEGORIES, TRACKING_STATUS_CATEGORY_COLORS, TrackingStatus, compareTrackingStatusOrder, getFinalStatuses, getNeverSkippableStatuses, getSuccessfulDeliveryStatuses, getTrackingStatusCategoryColor, getTrackingStatusColor, getTrackingStatusIcon, getTrackingStatusMetadata, getTrackingStatusTranslation, getTrackingStatusesByCategory, getWaitingAtPickupPointStatuses, isDeprecatedStatus, isFinalStatus, isNeverSkippableStatus, isSmartStatus, isSuccessfulDelivery };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map